import { render, staticRenderFns } from "./login-page.vue?vue&type=template&id=b925b518&scoped=true&"
import script from "./login-page.vue?vue&type=script&lang=js&"
export * from "./login-page.vue?vue&type=script&lang=js&"
import style0 from "./login-page.vue?vue&type=style&index=0&lang=less&"
import style1 from "./login-page.vue?vue&type=style&index=1&id=b925b518&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b925b518",
  null
  
)

export default component.exports